import type { SVGProps } from 'react';

const SvgAnchorLink = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="anchorlink" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M18.44 2.25A7.99 7.99 0 0 1 24.07 0c2.1.02 4.1.86 5.59 2.34A8.015 8.015 0 0 1 32 7.93a7.99 7.99 0 0 1-2.25 5.63l-.02.02-6.4 6.4c-1.5 1.5-3.53 2.34-5.66 2.34s-4.16-.84-5.66-2.34l2.26-2.26c.9.9 2.12 1.41 3.39 1.41s2.49-.51 3.39-1.41l6.39-6.39a4.79 4.79 0 0 0-.07-6.72 4.835 4.835 0 0 0-3.35-1.41c-1.25-.01-2.46.47-3.37 1.34L18.9 6.29c-.62.62-1.64.62-2.26 0-.62-.62-.62-1.64 0-2.26l1.76-1.76.02-.02Z"
    />
    <path
      fill={props.color}
      d="M8.82 11.86c1.5-1.5 3.53-2.34 5.66-2.34s4.16.84 5.66 2.34l-2.26 2.26c-.9-.9-2.12-1.41-3.39-1.41s-2.49.51-3.39 1.41l-6.4 6.4-.02.02c-.46.44-.82.97-1.08 1.56-.25.59-.38 1.22-.39 1.85 0 .64.12 1.27.36 1.86a4.8 4.8 0 0 0 2.63 2.63c.59.24 1.22.36 1.86.36.64 0 1.27-.14 1.85-.39.59-.25 1.12-.62 1.56-1.08l.02-.02 1.76-1.76c.63-.62 1.64-.62 2.26 0 .62.63.62 1.64 0 2.26l-1.75 1.75a8.035 8.035 0 0 1-5.68 2.43 8.034 8.034 0 0 1-5.73-2.35A7.919 7.919 0 0 1 .6 27.01c-.41-.96-.6-2.02-.6-3.08s.23-2.11.65-3.09c.42-.97 1.02-1.85 1.78-2.59l6.39-6.39Z"
    />
  </svg>
);

export default SvgAnchorLink;
